import Layout from "../../newlogin/components/layout"
import HeroSlider from "../../newlogin/components/hero-slider"
import { Button } from "../../newlogin/components/ui/button"
import { Shield, Clock, Users, TrendingUp } from "lucide-react"
import { getOrgConfig } from "../../../utils/organizationConfigUtil"

export default function HomePage() {
  const whyChooseTitle = getOrgConfig()?.labels?.whyChooseTitle;
  return (
    <Layout>
      {/* Hero Section - Full Screen Slider */}
      <section className="relative">
        <HeroSlider />
      </section>

      {/* Professional Images Slider Section */}
      {/* <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Meet Our Professional Team</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Independent mortgage professionals backed by a dedicated support team committed to your success.
            </p>
          </div>
          <HeroSlider />
        </div>
      </section> */}

      {/* Features Section */}
      <section id="features" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{whyChooseTitle}</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide the tools, support, and expertise you need to succeed in today's competitive mortgage market.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                <Shield className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">Reliable Support</h3>
              <p className="text-gray-600">
                Dedicated account management and processing support throughout the entire loan lifecycle.
              </p>
            </div>

            <div className="text-center space-y-4">
              <div className="w-16 h-16 brand-bg-soft rounded-full flex items-center justify-center mx-auto">
                <Clock className="h-8 w-8 brand-text-static" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">Fast Processing</h3>
              <p className="text-gray-600">
                Lightning-fast underwriting process with minimal friction to close loans quickly.
              </p>
            </div>

            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto">
                <Users className="h-8 w-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">Expert Team</h3>
              <p className="text-gray-600">
                Experienced professionals who understand the unique challenges of non-QM lending.
              </p>
            </div>

            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <TrendingUp className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">Growth Focused</h3>
              <p className="text-gray-600">
                Tools and resources designed to help you grow your production and expand your business.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-white">Ready to Partner with Champions Funding?</h2>
            <p className="text-xl text-blue-100">
              Join our network of successful mortgage professionals and start closing more loans today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 text-lg font-medium">
                Get Started Today
              </Button>
              <Button
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-blue-600 px-8 py-3 text-lg font-medium"
              >
                Contact Our Team
              </Button>
            </div>
          </div>
        </div>
      </section> */}
    </Layout>
  )
}
